const prodadminHosts = [
  'prodadmin.myxplor.com',
  'staging-admin.myxplor.com',
  'web.myxplor.com',
  'staging-web.myxplor.com',
  'staging-office.myxplor.com',
  'office.myxplor.com',
  'prodadmin.uktst.myxplor.com',
  'prodadmin.uk.myxplor.com',
]

// Allow test override via global variable (set before module evaluation)
// This is needed because jsdom does not allow reliably simulating iframe embedding by rewriting window.parent.
// In production, the override will be undefined and normal detection applies.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const testOverride = (window as any).__TEST_IS_EMBEDDED__

const isEmbedded: boolean =
  typeof testOverride === 'boolean' ? testOverride : window.parent.location !== window.location

const isProdAdminEmbedded: boolean =
  isEmbedded && document.referrer ? prodadminHosts.includes(new URL(document.referrer).host) : false

export { isEmbedded, isProdAdminEmbedded, prodadminHosts }
